import {get, post} from '~/utils/request';

export function getRecommendTalent(data){
  return post('/Referral/GetRecommendTalent', data);
}

export function getRecommendTalentFromUser(data){
  return post('/Referral/GetRecommendTalentFromUser', data);
}

export function lastRecommendInfo(data){
  return post('/Referral/LastRecommendInfo', data);
}

export function setRecommendPass(data){
  return post('/Referral/SetRecommendPass', data);
}

export function setRecommendRefuse(data){
  return post('/Referral/SetRecommendRefuse', data);
}

export function shareToEmail(data){
  return post('/Talent/ReferralShareToEmail', data);
}